<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "CdContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

      if (this.permissao("cd_menu_estoque_reserva_wms")) {
        m.push({
          titulo: "Consulta de Estoque e Reserva CD",
          titulo_app: "CD",
          icon: "mdi-file-document-outline",
          to: "/cd",
          tooltip: "Consulta de Estoque e Reserva de produtos",
        });
      }

			if (this.permissao("cd_dashboard")) {
				m.push({
					titulo: "CD",
					titulo_app: "CD",
					icon: "mdi-file-document-outline",
					to: "/cd",
					tooltip: "Dashboard Power BI CD",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>